import React from 'react';
import { RandomAreaPlotAnimation } from '@deephaven/components';
import "./Login.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Login(_ref) {
  var children = _ref.children,
    _ref$logoPath = _ref.logoPath,
    logoPath = _ref$logoPath === void 0 ? './logo.png' : _ref$logoPath;
  return /*#__PURE__*/_jsxs("div", {
    className: "login-container",
    children: [/*#__PURE__*/_jsx(RandomAreaPlotAnimation, {}), /*#__PURE__*/_jsxs("div", {
      className: "login-box",
      children: [/*#__PURE__*/_jsx("div", {
        className: "logo",
        children: /*#__PURE__*/_jsx("img", {
          src: logoPath,
          alt: "Deephaven Data Labs"
        })
      }), children, /*#__PURE__*/_jsxs("p", {
        className: "footer",
        children: ["\xA9 2016-", new Date().getFullYear(), " Deephaven Data Labs LLC. Patent Pending."]
      })]
    })]
  });
}
export default Login;
//# sourceMappingURL=Login.js.map